import {
    Autocomplete,
    Skeleton,
    TextField,
} from "@mui/material";
import { DefaultFormProps } from "./form.types";
import { Option } from "./SelectBox";
import React from "react";

interface MultiSelectProps extends DefaultFormProps {
    value?: any;
    options: Option[];
    isLoading?: boolean;
}

const defaultProps: Partial<MultiSelectProps> = {
    required: false,
    fullWidth: true,
    autoFocus: false,
    error: false,
    disabled: false,
    value: "",
    isLoading: false,
};

const MultiSelect = (props: MultiSelectProps) => {
    props = { ...defaultProps, ...props };
    const valueChange = (event: any, value: any[]) => {
        props.onChange(value);
    };

    return (
        <Autocomplete
            size="small"
            multiple={true}
            limitTags={2}
            getOptionLabel={(option) => option.label}
            fullWidth={props.fullWidth}
            disabled={props.disabled}
            options={props.options}
            onChange={valueChange}
            value={props.value}
            isOptionEqualToValue={(option, value) =>
                value.value === option.value
            }
            renderInput={(params) => (
                <TextField
                    {...params}
                    margin="normal"
                    label={props.label}
                    InputProps={{
                        ...params.InputProps,
                        startAdornment: props.isLoading ? (
                            <Skeleton width={"200%"} />
                        ) : (
                            params.InputProps.startAdornment
                        ),
                    }}
                />
            )}
        />
    );
};

export default MultiSelect;
